export interface KarmaQuote {
  text: string;
  attribution?: string;
}

export const KARMA_QUOTES: readonly KarmaQuote[] = [
  { text: 'Every act of care is a ripple that never stops.' },
  {
    text: 'The best way to find yourself is to lose yourself in the service of others.',
    attribution: 'Gandhi',
  },
  { text: 'Medicine is not only a science — it is also an art of human connection.' },
  {
    text: 'Wherever the art of medicine is loved, there is also a love of humanity.',
    attribution: 'Hippocrates',
  },
  {
    text: 'To do more for the world than the world does for you — that is success.',
    attribution: 'Henry Ford',
  },
  { text: 'Attention is the rarest and purest form of generosity.' },
  { text: 'Patients may forget your name, but they will never forget how you made them feel.' },
  { text: 'Caring is the essence of nursing — and of being human.', attribution: 'Jean Watson' },
  { text: 'Small acts, when multiplied by millions, can transform the world.' },
  { text: 'The secret of getting ahead is getting started.', attribution: 'Mark Twain' },
  { text: 'Each patient carries their own doctor inside them.' },
  { text: "A kind word can change someone's entire day." },
];

export function pickKarmaQuote(): KarmaQuote {
  return (
    KARMA_QUOTES[Math.floor(Math.random() * KARMA_QUOTES.length)] ?? {
      text: 'Every act of care is a ripple that never stops.',
    }
  );
}
